<template>
  <div class="tickets-list-wrapper">
    <display-navigation v-if="spotId === '0'" path="spots_list" title="景区详情" />
    <!-- <display-navigation path="tickets_list" title="景区详情" /> -->
    <display-swipe :items="swipes" />
    <display-spot-desc @getActiveTab="getActiveTab" />
    <div class="wrapper">
      <display-tickets :items="categories" v-if="activeTab === 0" />
      <display-description :value="description" v-if="activeTab === 1" />
      <display-description :value="note" v-if="activeTab === 2" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getTickets } from '@/api/api-ticket';
import { handelWeChatConfig } from '@/utils/util';

import DisplayNavigation from '@/components/DisplayNavigation.vue';
import DisplaySwipe from '@/components/DisplaySwipe.vue';
import DisplayTickets from '@/components/DisplayTickets.vue';
import DisplaySpotDesc from '@/components/DisplaySpotDesc.vue';
import DisplayDescription from '@/components/DisplayDescription.vue';

export default {
  components: {
    DisplayNavigation,
    DisplaySwipe,
    DisplayTickets,
    DisplaySpotDesc,
    DisplayDescription,
  },
  data() {
    return {
      swipes: [],
      categories: [],
      description: '',
      spotDetail: {},
      note: '',
      // 0:预约购票，1：景区介绍，2:购票须知
      activeTab: 0,
    };
  },
  computed: {
    ...mapGetters(['spotId']),
    id() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.handleGet();
    handelWeChatConfig();
  },
  methods: {
    async handleGet() {
      const { desc, list, slides, spot, ticketing_instructions: note } = await getTickets(this.id);
      this.swipes = slides;
      this.categories = list;
      this.description = desc;
      this.spotDetail = spot;
      this.note = note;
    },
    getActiveTab(index) {
      this.activeTab = index;
    },
  },
};
</script>
<style lang="less" scoped>
.tickets-list-wrapper {
  margin-bottom: 60px;
  padding: 10px 18px 0;
}
</style>
